export default "__VITE_ASSET__ACgYICeO__"